module.exports = __webpack_public_path__ + "static/media/event-image-alt.e9c185aa.png";